/**
 * Provider-specific fixes for external legal-source URLs.
 *
 * Some indexed sources store a URL variant that 404s on the live site.
 * Known cases:
 *  - wetten.overheid.nl: indexed URLs contain a `/id/` segment
 *    (e.g. https://wetten.overheid.nl/id/BWBR0012141/2001-01-04/0) but the
 *    public site serves the document WITHOUT it
 *    (https://wetten.overheid.nl/BWBR0012141/2001-01-04/0).
 *
 * Apply this before opening/linking any external source URL.
 */
export const normalizeSourceUrl = (url?: string | null): string => {
  if (!url) return url || '';
  try {
    const u = new URL(url);
    if (u.hostname === 'wetten.overheid.nl' || u.hostname.endsWith('.wetten.overheid.nl')) {
      // Drop a leading `/id/` path segment — the live site 404s on it.
      u.pathname = u.pathname.replace(/^\/id\//, '/');
    }
    return u.toString();
  } catch {
    // Not a parseable URL — do a targeted string replace as a fallback.
    return url.replace(/(wetten\.overheid\.nl)\/id\//, '$1/');
  }
};
